<template>
  <div class="foot">
    <div class="fo-con">
      <div class="fc fc-1">
        <div class="top">
          <div class="img-b">
            <img src="@/assets/img/header/logo.png" >
          </div>
          <div class="t-r">
            <div class="t1 gold-text">RWABS</div>
            <div class="t2">RWA Business Schoo</div>
          </div>
        </div>
        <div class="text">
          {{ $t('foot.p1') }}
        </div>
      </div>
      <div class="fc fc-2">
        <div class="f-i gold-text f-n">{{ $t('foot.p1_1') }}</div>
        <div class="f-i link">{{ $t('foot.p2') }}<i class="el-icon-link"></i> </div>
        <div class="f-i link">BscScan<i class="el-icon-link"></i></div>
        <div class="f-i link">MetaMask<i class="el-icon-link"></i></div>
      </div>
      <div class="fc fc-2">
        <div class="f-i gold-text f-n">{{ $t('foot.p3') }}</div>
        <div class="f-i link" @click="toPage('https://x.com/RWACollege')">Twitter<i class="el-icon-link"></i></div>
        <div class="f-i link">Discord<i class="el-icon-link"></i></div>
        <div class="f-i link" @click="toPage('https://t.me/+XI-q8tSSrPMyMDE1')">Telegram<i class="el-icon-link"></i></div>
      </div>
      <div class="fc fc-2">
        <div class="f-i gold-text f-n">{{ $t('foot.p4') }}</div>
        <div class="f-i link">{{ $t('foot.p5') }}</div>
        <div class="f-i link">{{ $t('foot.p6') }}</div>
        <div class="f-i link">{{ $t('foot.p7') }}</div>
      </div>
    </div>
    <div class="bot-box">
      <div class="bot">
        <span>© 2026 RWABS - RWA Business School. All rights reserved.</span>
        <span>Powered by <span class="gold">BSC</span> </span>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  name: 'Header',
  methods: {
    toPage(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
@import './style.scss';
@import './h5-style.scss';
</style>